export const psychologistStrings = {
  global: {
    instituteName: "מכון מיכאל",
    subtitle: "טיפול פסיכולוגי אינטגרטיבי",
    therapistName: "מיכאל זאייצ'יק",
    license: "מ.ר 27-179266",
    specialization: "מתמחה בפסיכולוגיה קלינית"
  },
  
  navigation: {
    about: "אודות",
    treatmentAreas: "תחומי טיפול", 
    education: "השכלה וניסיון",
    contact: "צור קשר"
  },
  
  hero: {
    title: "מכון מיכאל",
    subtitle: "טיפול פסיכולוגי אינטגרטיבי",
    therapistInfo: "מיכאל זאייצ'יק, מתמחה בפסיכולוגיה קלינית",
    license: "מ.ר 27-179266",
    mainMessage: "אני מאמין בכוחו של הקשר האנושי כמרחב לצמיחה, ריפוי והבנה עצמית עמוקה",
    primaryButton: "קבע פגישה",
    secondaryButton: "למידע נוסף"
  },
  
  about: {
    title: "אודות",
    philosophy1: "אני מאמין בכוחו של הקשר האנושי כמרחב לצמיחה, ריפוי והבנה עצמית עמוקה. עבורי, טיפול הוא מפגש שמזמין חקירה משותפת של כאב, צרכים וכמיהות -- ושל הדרכים שבהן אנו לומדים לשאת את חוסר הוודאות שבחיים.",
    
    philosophy2: "הגישה שלי מבוססת על חשיבה פסיכודינמית, ומשלבת כלים מעשיים והתבוננות רחבה על עולמו הפנימי של האדם -- מהשפעות מוקדמות ויחסי עבר, ועד למשמעות, משחקיות וחיפוש אחר חופש נפשי בהווה. אני מאמין ששינוי מתרחש כשנוצר מרחב שבו אפשר להיות בדיוק כפי שאתה - בלי מסכות, בלי שיפוט, עם סקרנות, הקשבה ואומץ לנוע יחד דרך המקומות הכואבים והלא פתורים.",
    
    philosophy3: "טיפול טוב, בעיניי, הוא תהליך יעיל לפתרון בעיות וגם מסע עמוק לגילוי עצמי ולבניית חיים אותנטיים. זהו תהליך שמותאם לצרכיו ומטרותיו של האדם ולוקח בחשבון את היכולות, המשאבים ואירועי החיים שהוא עבר."
  },
  
  treatmentAreas: {
    title: "תחומי טיפול",
    subtitle: "מטפל בילדים, נוער ומבוגרים בגישה דינמית בשילוב כלים מעולמות ה-ACT, ה-CBT ומיינדפולנס",
    
    childrenAndAdolescents: {
      title: "עבודה עם ילדים ונוער",
      items: [
        "בעיות התנהגות בבית ובמסגרת החינוכית",
        "חרדת נטישה וחרדת פרידה", 
        "בעיות חברתיות ובידוד חברתי",
        "גירושי הורים והסתגלות למשפחות חדשות",
        "קשיים סביב גיל ההתבגרות וזהות עצמית",
        "קשיי קשב וריכוז (ADHD)"
      ]
    },
    
    adults: {
      title: "עבודה עם מבוגרים",
      items: [
        "התמודדות עם בדידות או תחושת ריק",
        "שאלות של משמעות, זהות ובחירות חיים",
        "קשיים במעבר להורות או בזוגיות",
        "הדרכות הורים בגישה אינטגרטיבית"
      ]
    },
    
    clinicalIssues: {
      title: "נושאים קליניים",
      items: [
        "הפרעות חרדה, פוביות, OCD",
        "קשיי הסתגלות לשינויים ומעברים",
        "אוטיזם והקשת האוטיסטית",
        "דימוי עצמי נמוך ותחושת מסוגלות נמוכה",
        "קשיים בוויסות הרגשי והתנהגותי",
        "שליטה בכעסים",
        "קושי במערכות יחסים בין-אישיות"
      ]
    }
  },
  
  education: {
    title: "השכלה והכשרה מקצועית",
    
    experience: {
      title: "ניסיון מקצועי",
      institutions: [
        {
          name: "מכון חיבורים",
          description: "המכון הישראלי לטיפול בחרדה"
        },
        {
          name: "מכון שלם", 
          description: "טיפול ואבחון לילד ולמשפחה"
        },
        {
          name: "המחלקה לאשפוז פסיכיאטרי",
          description: "מחלקה סגורה ב' המרכז הרפואי \"שיבא\" תל השומר"
        },
        {
          name: "קליניקת ברוך איבצ'ר",
          description: "טיפול בגישת ACT למבוגרים"
        },
        {
          name: "אוניברסיטת רייכמן, הרצליה",
          description: ""
        }
      ],
      additional: [
        "מדריך שיקום ומתאם טיפול במגוון מסגרות שיקום ברחבי הארץ",
        "התנדבות בעמותת \"עלם\" - פרויקט \"כתובת רחוב\""
      ]
    },
    
    academicBackground: {
      title: "השכלה ומחקר",
      degrees: [
        {
          level: "תואר שני M.A",
          field: "בפסיכולוגיה קלינית, אוניברסיטת רייכמן (בהצטיינות)"
        },
        {
          level: "תואר ראשון B.A", 
          field: "בפסיכולוגיה, האוניברסיטה הפתוחה (בהצטיינות יתרה)"
        }
      ],
      research: {
        title: "תחום המחקר",
        description: "התאמות תרבותיות של התוכנית \"הפחתת מתחים באמצעות מודעות קשובה\" (MBSR) לקהילת ישראלים ממוצא אתיופי בישראל ובדיקת השפעתה על הגברת החוסן הנפשי ויכולת ההתמודדות עם אפליה וגזענות -- 2023",
        supervisor: "בהנחיית פרופ' נאוה לויט בן נון"
      }
    }
  },
  
  contact: {
    title: "צור קשר",
    subtitle: "מוזמן ליצור קשר לקביעת פגישה או לכל שאלה",
    form: {
      nameLabel: "שם מלא",
      namePlaceholder: "הזן את השם המלא שלך",
      emailLabel: "כתובת אימייל", 
      emailPlaceholder: "הזן את כתובת האימייל שלך",
      phoneLabel: "מספר טלפון",
      phonePlaceholder: "050-",
      messageLabel: "הודעה",
      messagePlaceholder: "ספר בקצרה על מה שמעסיק אותך או על הסיבה לפנייה...",
      submitButton: "שלח הודעה",
      sendingButton: "שולח...",
      fillAllFields: "אנא מלא את כל השדות הנדרשים.",
      thankYou: "תודה",
      successMessage: "ההודעה נשלחה בהצלחה. אחזור אליך בהקדם.",
      errorMessage: "שגיאה בשליחת ההודעה. אנא נסה שוב או צור קשר טלפונית."
    },
    info: {
      phone: "050-1234567",
      email: "michael.psychology@gmail.com", 
      hours: "ראשון - חמישי: 09:00 - 18:00",
      emergency: "במקרה של חירום נפשי, פנה למוקד 1201 או לחדר מיון"
    }
  }
};